import request from '@/api/config/request'

const prex = "public/";

export function getIndex() {
    return request({
        url: `${prex}index`,
        method: 'get',
    })
}

export function validaNota(data) {
    return request({
        url: `${prex}valida_nota`,
        method: 'post',
        data
    })
}